'use strict';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../core/api.service';
import { SyncCryptService } from '../../core/crypt/sync-crypt.service';
import { LoggerService } from '../../core/logger.service';
import { ErrorMessages } from '../../shared/models';
import { AuthService } from '../services/auth.service';
import { ResetpasswordpubkeyApiOutput } from '../../shared/models/api/resetpasswordpubkey-api.model';
import { PasswordService } from '../services/password.service';
@Component({
    selector: 'sync-password-reset',
    templateUrl: './password-reset.component.html',
    styleUrls: ['./password-reset.component.css'],
})
export class PasswordResetComponent implements OnInit {

    private bCrypt: bCrypt;
    private cachekey: string;
    public resetCode: string;
    public newPass1: string;
    public newPass2: string;
    public twofacode: string;
    public errors: Array<sync.IErrorCode> = [];
    public success = false;
    public req2FA = false;
    public spinner = false;

  constructor(
    private apiService: ApiService,
    private loggerService: LoggerService,
    private auth: AuthService,
    private crypt: SyncCryptService,
    private route: ActivatedRoute,
    private router: Router,
    private pwdService: PasswordService
    ) {
        this.bCrypt = new bCrypt();
}

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.cachekey = params['cachekey'];
        });
    }

public submit() {
    this.errors = [];
    if (!this.pwdService.isPasswordStrong(this.newPass1)) {
        this.errors.push({ code : 8304});
        this.newPass1 = undefined;
        this.newPass2 = undefined;
        return;
    }
    if (this.newPass1 != this.newPass2) {
        this.errors.push({ code: 8121 });
        this.newPass1 = undefined;
        this.newPass2 = undefined;
        return;
    }
    this.errors = [];
    this.spinner = true;
    this.resetPassword(
        this.resetCode,
        this.cachekey,
        this.newPass1,
        this.twofacode
    ).then(() => {
        this.spinner = false;
        this.success = true;
        this.resetCode = undefined;
        this.newPass1 = undefined;
        this.newPass2 = undefined;
        this.router.navigate(['/login'], { queryParams : { passwordreset: 1 }});
    }, (err) => {
        this.spinner = false;
        // if an error occurred, show error
        if (err && err.error_code) {
            let msg = err.error_msg || '';
            if (err.error_code == 8022 || err.error_code == 8023) {
                this.req2FA = true;
                msg = ErrorMessages[err.error_code];
                return;
            }
            this.loggerService.error('An error occurred password reset');
            this.loggerService.error(msg);
            this.errors.push({ code: err.error_code, msg: msg });
        } else if (err && err.code) {
            if (err.code == 8022 || err.code == 8023) {
                this.req2FA = true;
                return;
            }
            this.errors.push(err);
                } else {
                    this.loggerService.error('An error occurred');
                    this.loggerService.error(err);
                    this.errors.push({
                        code: 9000,
                        msg: 'An unknown error occurred',
                    });
                }
            }
        );
    }

    public async resetPassword(
        code: string,
        cachekey: string,
        passwordPlain: string,
        twofacode?: string
    ) {
        const hashPass = await this.auth.hashPassword(
            this.bCrypt.gensalt(8),
            passwordPlain
        );
        const pubkey = await this.apiService.fetchText(
            '/key/password-recover/pubkey'
        );
        const passResetKeys = await this.crypt.prepareResetPasswords(
            passwordPlain,
            pubkey
        );
        const pubkeyOut =
            await this.apiService.send<ResetpasswordpubkeyApiOutput>(
                'resetpasswordpubkey',
                {
                    cachekey: cachekey,
                    code: code,
                }
            );
        const encPassword = await this.crypt.userpasswordEncrypt(
            passwordPlain,
            pubkeyOut.pub_key
        );

        return await this.apiService.execute('resetpassword', {
            enc_pass_meta: passResetKeys.encPassMeta,
            salt_meta: passResetKeys.metaSalt,
            enc_pass_priv: passResetKeys.encPassPriv,
            salt_priv: passResetKeys.privSalt,
            password_hash: hashPass,
            enc_password: encPassword,
            code: code,
            cachekey: cachekey,
            twofacode: twofacode,
        });
    }
}
